import { AscProjectMonthAllocation } from '@common/neo.tax';
import { ColorStop, colors, createLinearGradientCss, getRecipeColor } from '@ui-components/neo.tax';

import { getProjectColorVariant } from '@neo.tax/shared';

export const getBgColorsForMonthPill = ({
  allocation,
}: {
  allocation: Pick<AscProjectMonthAllocation, 'ascProjectId' | 'useAllocationPercent' | 'allocationPercent'>[];
}): string => {
  const bgColors = allocation.reduce((acc: [string, ColorStop[]][], projectAllocation, index) => {
    const colorStopStart = index === 0 ? 0 : acc[index - 1][1][1];
    const color = getRecipeColor(getProjectColorVariant(index), 'whiteBg').text;
    acc.push([
      color,
      [
        colorStopStart,
        colorStopStart + (projectAllocation.useAllocationPercent ?? projectAllocation.allocationPercent),
      ],
    ]);
    return acc;
  }, []);

  const lastColorStop = bgColors[bgColors.length - 1]?.[1][1] ?? 0;
  bgColors.push([colors.black, [lastColorStop, 100]]);

  return createLinearGradientCss({
    direction: 'to right',
    colors: bgColors,
  });
};
